import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import ContentPage from 'src/components/ContentPage/ContentPage';
import DataTableV3 from 'src/components/DataTableV3';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import { sivaGoalsDetailsColumns } from '../constants/siva-goals-details-columns';
import { useSivaGoalsDetailsList } from '../../hooks/use-siva-goals-details-list';
import { DataTableV3Ids } from 'src/constants/dataTableIds';

const SivaAdminGoalsYearPage: React.FC = () => {
  const { t: tCommon } = useTranslation();
  const { t: tTableTitles } = useTranslation('tableTitles');

  const { year } = useParams();

  const { data, isLoading } = useSivaGoalsDetailsList(year ? parseInt(year) : undefined);

  if (!year || !year.match(/[2][0-9]{3}/)) {
    return <ContentPage title="Ugyldig år" />;
  }

  if (isLoading) {
    return <LoadingPage aria-label="Laster data..." />;
  }

  return (
    <ContentPage title={`Måltall ${year}`} documentTitle={`Måltall for ${year} - Siva Admin`}>
      <DataTableV3
        id={DataTableV3Ids.SivaAdmin.GoalsPerYear}
        data={data}
        columns={sivaGoalsDetailsColumns}
        translationFn={(key: string) => tTableTitles(key as any)}
        texts={{
          globalFilterPlaceholder: 'Søk i måltall',
          rowsPerPage: tCommon('rowsPerPage'),
          of: tCommon('of'),
        }}
        disableExport
        disableColumnEditor
      />
    </ContentPage>
  );
};

export default SivaAdminGoalsYearPage;
